(function () {
  'use strict';

  function parseJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_) {
      return [];
    }
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function partCount(count) {
    if (count === null || count === undefined) return 'Shop products';
    var amount = Number(count || 0);
    return amount.toLocaleString() + (amount === 1 ? ' part' : ' parts');
  }

  function initials(title) {
    return String(title || '')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) { return part.charAt(0); })
      .join('')
      .toUpperCase();
  }

  function firstLetter(title) {
    var first = String(title || '').trim().charAt(0).toUpperCase();
    return /[A-Z]/.test(first) ? first : '#';
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function link(className, href, text) {
    var node = element('a', className, text);
    node.href = href;
    return node;
  }

  function exploreUrl(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=explore';
  }

  function createBrandCard(brand) {
    var card = element('article', 'discovery-brand-card');
    var media = link('discovery-brand-card__media', brand.url);
    media.setAttribute('aria-label', 'Shop ' + brand.title + ' products');

    if (brand.image) {
      var image = element('img');
      image.src = brand.image;
      image.alt = brand.title + ' logo';
      image.loading = 'lazy';
      image.width = 360;
      image.height = 220;
      media.appendChild(image);
    } else {
      media.appendChild(element('span', 'discovery-brand-card__initials', initials(brand.title)));
    }

    var body = element('div', 'discovery-brand-card__body');
    body.append(
      element('h2', 'discovery-brand-card__title', brand.title),
      element('p', 'discovery-brand-card__count', partCount(brand.count))
    );

    var actions = element('div', 'discovery-brand-card__actions');
    actions.append(
      link('discovery-link discovery-link--primary', brand.url, 'Shop brand'),
      link('discovery-link', exploreUrl(brand.url), 'Explore categories')
    );

    card.append(media, body, actions);
    return card;
  }

  function initBrandBrowser(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var collectionBrands = parseJson(root, '[data-brand-collections]');
    var vendorBrands = parseJson(root, '[data-brand-vendors]');
    var search = root.querySelector('[data-brand-search]');
    var letters = root.querySelector('[data-brand-letters]');
    var grid = root.querySelector('[data-brand-grid]');
    var empty = root.querySelector('[data-brand-empty]');
    var summary = root.querySelector('[data-brand-summary]');
    if (!search || !letters || !grid || !empty || !summary) return;

    var brandMap = new Map();
    vendorBrands.forEach(function (brand) {
      brandMap.set(normalize(brand.title), brand);
    });
    collectionBrands.forEach(function (brand) {
      brandMap.set(normalize(brand.title), brand);
    });

    var brands = Array.from(brandMap.values())
      .filter(function (brand) { return brand.title && brand.url; })
      .sort(function (a, b) { return a.title.localeCompare(b.title); });
    var availableLetters = ['All'].concat(Array.from(new Set(brands.map(function (brand) {
      return firstLetter(brand.title);
    }))));
    var activeLetter = 'All';

    function renderLetters(focusLetter) {
      letters.replaceChildren();
      availableLetters.forEach(function (letter) {
        var button = element('button', 'discovery-letter', letter);
        button.type = 'button';
        button.dataset.brandLetter = letter;
        button.setAttribute('aria-pressed', letter === activeLetter ? 'true' : 'false');
        if (letter === activeLetter) button.classList.add('is-active');
        letters.appendChild(button);
      });
      if (focusLetter) {
        var nextButton = Array.from(letters.querySelectorAll('[data-brand-letter]')).find(function (button) {
          return button.dataset.brandLetter === focusLetter;
        });
        if (nextButton) nextButton.focus({ preventScroll: true });
      }
    }

    function render(focusLetter) {
      var term = normalize(search.value);
      var filtered = brands.filter(function (brand) {
        var matchesLetter = activeLetter === 'All' || firstLetter(brand.title) === activeLetter;
        return matchesLetter && (!term || normalize(brand.title).includes(term));
      });

      grid.replaceChildren();
      filtered.forEach(function (brand) {
        grid.appendChild(createBrandCard(brand));
      });
      grid.hidden = filtered.length === 0;
      empty.hidden = filtered.length > 0;
      summary.textContent = filtered.length.toLocaleString() + (filtered.length === 1 ? ' brand' : ' brands');
      renderLetters(focusLetter);
    }

    letters.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-brand-letter]');
      if (!trigger) return;
      activeLetter = trigger.dataset.brandLetter;
      search.value = '';
      render(activeLetter);
    });
    search.addEventListener('input', function () {
      activeLetter = 'All';
      render();
    });
    render();
  }

  function cleanSubcategoryTitle(title, parentTitle) {
    var prefix = String(parentTitle || '') + ' - ';
    var next = String(title || '');
    return next.indexOf(prefix) === 0 ? next.slice(prefix.length).trim() : next;
  }

  function createCategoryCard(category) {
    var card = element('article', 'discovery-category-card');
    var button = element('button', 'discovery-category-card__button');
    button.type = 'button';
    button.dataset.categoryKey = category.key;
    button.append(
      element('span', 'discovery-category-card__count', partCount(category.count)),
      element('h2', 'discovery-category-card__title', category.title),
      element(
        'span',
        'discovery-category-card__meta',
        category.children.length.toLocaleString() +
          (category.children.length === 1 ? ' subcategory' : ' subcategories')
      )
    );

    var preview = element('span', 'discovery-category-card__preview');
    category.children.slice(0, 4).forEach(function (child) {
      preview.appendChild(element('span', '', child.displayTitle));
    });
    if (!category.children.length) preview.appendChild(element('span', '', 'Shop the full category'));
    button.append(preview, element('span', 'discovery-category-card__cta', 'Explore category →'));

    card.append(button, link('discovery-category-card__shop', category.url, 'Shop all'));
    return card;
  }

  function createSubcategoryCard(category, child) {
    var card = link('discovery-subcategory-card', child.url);
    card.append(
      element('span', '', category.title),
      element('strong', '', child.displayTitle),
      element('em', '', partCount(child.count))
    );
    return card;
  }

  function initCategoryBrowser(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var collections = parseJson(root, '[data-category-source]');
    var grid = root.querySelector('[data-category-grid]');
    var overview = root.querySelector('[data-category-overview]');
    var detail = root.querySelector('[data-category-detail]');
    var empty = root.querySelector('[data-category-empty]');
    var search = root.querySelector('[data-category-search]');
    var back = root.querySelector('[data-category-back]');
    var subgrid = root.querySelector('[data-category-subgrid]');
    var detailTitle = root.querySelector('[data-category-detail-title]');
    var detailMeta = root.querySelector('[data-category-detail-meta]');
    var detailLink = root.querySelector('[data-category-detail-link]');
    var subcount = root.querySelector('[data-category-subcount]');
    if (!grid || !overview || !detail || !empty || !search || !back || !subgrid) return;

    var byHandle = new Map(collections.map(function (item) { return [item.handle, item]; }));
    var byTitle = new Map(collections.map(function (item) { return [normalize(item.title), item]; }));
    var groups = new Map();

    collections.forEach(function (item) {
      var titleParts = String(item.title || '').split(' - ');
      var explicitParent = item.parentHandle && byHandle.get(item.parentHandle);
      var parentTitle = item.parentTitle || (explicitParent && explicitParent.title) || (titleParts.length > 1 ? titleParts[0] : '');
      var isSubcategory = String(item.type || '').toLowerCase().includes('sub') || Boolean(parentTitle);

      if (!isSubcategory) {
        var ownKey = normalize(item.title);
        var existing = groups.get(ownKey) || { key: ownKey, children: [] };
        groups.set(ownKey, Object.assign(existing, item, { key: ownKey, children: existing.children }));
        return;
      }

      var parentKey = normalize(parentTitle);
      var parent = byTitle.get(parentKey) || explicitParent || {
        title: parentTitle,
        handle: parentKey,
        url: '/collections/' + parentKey,
        count: 0
      };
      if (!groups.has(parentKey)) groups.set(parentKey, Object.assign({}, parent, { key: parentKey, children: [] }));
      groups.get(parentKey).children.push(Object.assign({}, item, {
        displayTitle: cleanSubcategoryTitle(item.title, parent.title)
      }));
    });

    var lastCategoryKey = '';
    var categories = Array.from(groups.values())
      .filter(function (category) {
        return category.title && (Number(category.count || 0) > 0 || category.children.length > 0);
      })
      .map(function (category) {
        category.children = category.children
          .filter(function (child) { return Number(child.count || 0) > 0; })
          .sort(function (a, b) {
            return Number(b.count || 0) - Number(a.count || 0) || a.displayTitle.localeCompare(b.displayTitle);
          });
        return category;
      })
      .sort(function (a, b) {
        return Number(b.count || 0) - Number(a.count || 0) || a.title.localeCompare(b.title);
      });

    function categoryFromHash() {
      var match = window.location.hash.match(/^#category=(.+)$/);
      return match ? decodeURIComponent(match[1]) : '';
    }

    function renderOverview(updateHistory, focusKey) {
      var term = normalize(search.value);
      var filtered = categories.filter(function (category) {
        return !term ||
          normalize(category.title).includes(term) ||
          category.children.some(function (child) { return normalize(child.displayTitle).includes(term); });
      });

      grid.replaceChildren();
      filtered.forEach(function (category) {
        grid.appendChild(createCategoryCard(category));
      });
      empty.hidden = filtered.length > 0;
      overview.hidden = filtered.length === 0;
      detail.hidden = true;
      if (updateHistory && window.location.hash) {
        window.history.pushState({ category: '' }, '', window.location.pathname + window.location.search);
      }
      if (focusKey) {
        var nextTrigger = grid.querySelector('[data-category-key="' + focusKey + '"]');
        if (nextTrigger) nextTrigger.focus({ preventScroll: true });
        else search.focus({ preventScroll: true });
      }
    }

    function renderDetail(key, updateHistory, moveFocus) {
      var category = categories.find(function (item) { return item.key === key; });
      if (!category) return;
      detailTitle.textContent = category.title;
      detailMeta.textContent =
        partCount(category.count) + ' across ' + category.children.length.toLocaleString() +
        (category.children.length === 1 ? ' subcategory.' : ' subcategories.');
      detailLink.href = category.url;
      subcount.textContent = category.children.length
        ? 'Choose a focused section or shop the full category.'
        : 'No subcategories are published for this category yet.';
      subgrid.replaceChildren();
      category.children.forEach(function (child) {
        subgrid.appendChild(createSubcategoryCard(category, child));
      });
      overview.hidden = true;
      empty.hidden = true;
      detail.hidden = false;
      if (updateHistory !== false && categoryFromHash() !== key) {
        window.history.pushState(
          { category: key },
          '',
          window.location.pathname + window.location.search + '#category=' + encodeURIComponent(key)
        );
      }
      root.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      if (moveFocus) {
        detailTitle.setAttribute('tabindex', '-1');
        detailTitle.focus({ preventScroll: true });
      }
    }

    grid.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-category-key]');
      if (trigger) {
        lastCategoryKey = trigger.dataset.categoryKey;
        renderDetail(lastCategoryKey, true, true);
      }
    });
    back.addEventListener('click', function () { renderOverview(true, lastCategoryKey); });
    search.addEventListener('input', function () { renderOverview(false); });
    window.addEventListener('popstate', function () {
      var key = categoryFromHash();
      if (key) {
        lastCategoryKey = key;
        renderDetail(key, false, true);
      } else renderOverview(false, lastCategoryKey);
    });
    var initialCategory = categoryFromHash();
    if (initialCategory) {
      lastCategoryKey = initialCategory;
      renderDetail(initialCategory, false, false);
    }
    else renderOverview(false);
  }

  function initialize(scope) {
    (scope || document).querySelectorAll('[data-alliance-brand-browser]').forEach(initBrandBrowser);
    (scope || document).querySelectorAll('[data-alliance-category-browser]').forEach(initCategoryBrowser);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
